import React from 'react';
import {Flex} from '@priority-software/priority-style-react';
import styles from '.././styles.module.scss';
import cx from 'classnames';
import {ContentBtn} from './ContentBtn';

type Props = {
    dotsCounter: number;
    curPageIndex: number;
    isWelcomePage: boolean;
    handleConfirmBtn: () => void;
    handleBackBtn: () => void;
    forwardBtnText: string;
    backwardsBtnText: string;
};

export const Footer = (props: Props) => {
    const {
        dotsCounter,
        curPageIndex,
        isWelcomePage,
        handleConfirmBtn,
        handleBackBtn,
        forwardBtnText,
        backwardsBtnText
    } = props;

    const dots: string[] = [];
    if (!!dotsCounter) {
        for (let i = 0; i < dotsCounter; i++) {
            dots.push(curPageIndex === i ? styles.fullDot : styles.emptyDot);
        }
    }
    return (
        <Flex
            justifyContent="center"
            alignItems="center"
            direction="column"
            componentClasses={styles.footer}
        >
            <ContentBtn
                isWelcomePage={isWelcomePage}
                handleConfirmBtn={handleConfirmBtn}
                handleBackBtn={handleBackBtn}
                forwardBtnText={forwardBtnText}
                backwardsBtnText={backwardsBtnText}
            />

            <Flex justifyContent="center" alignItems="center" componentClasses={styles.dotsHeight}>
                {!!dotsCounter &&
                    dots.map((dot, index) => {
                        return <span key={index} className={cx(styles.dot, dot)}></span>;
                    })}
            </Flex>
        </Flex>
    );
};
